<template>
  <footer class="main-footer dark-footer">
    <div class="container mb-60">
      <div class="row">
        <div class="col-md-4">
          <div class="footer-widget fl-wrap">
            <h3 class="text-center">Kövess minket:</h3>
            <ul class="social-icons">
              <li>
                <a
                  href="https://www.facebook.com/petkupa/"
                  target="_blank"
                  title="Facebook"
                >
                  <i class="fab fa-facebook-square"></i>
                </a>
              </li>
              <li>
                <a
                  href="https://www.instagram.com/petkupa/?hl=en"
                  target="_blank"
                  title="Instagram"
                >
                  <i class="fab fa-instagram-square"></i>
                </a>
              </li>
              <li>
                <a
                  href="https://www.youtube.com/c/PETKupa"
                  target="_blank"
                  title="YouTube"
                >
                  <i class="fab fa-youtube-square"></i>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="col-md-4">
          <div class="footer-widget fl-wrap">
            <div class="widget-posts fl-wrap">
              <h3 class="text-center">A kezdeményezés ötletgazdái:</h3>
              <ul>
                <li class="clearfix">
                  <a href="https://petkupa.hu/hu_HU/" target="_blank">
                    <img
                      src="../../assets/images/logos/PET_logo_feher.png"
                      class="logo"
                      alt=""
                  /></a>
                </li>
                <li>
                  <a href="https://termeszetfilm.hu" target="_blank">
                    <img
                      src="../../assets/images/tamogatok/THU-LOGO-ORANGE-FINAL_kicsi-300x132.png"
                      class=""
                      alt=""
                    />
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="footer-widget fl-wrap">
            <h3 class="text-center">Támogatóink:</h3>
            <div class="footer-contacts-widget fl-wrap">
              <ul class="footer-contacts partners fl-wrap border-0 pt-0 mt-0">
                <li>
                  <img
                    src="../../assets/images/tamogatok/TidyUP_logo.jpg"
                    class="p-10 bg-white"
                    alt=""
                  />
                </li>
                <li>
                  <img
                    src="../../assets/images/tamogatok/kszgysz_logo.png"
                    class="px-20 py-10 bg-white"
                    alt=""
                  />
                </li>
                <li>
                  <img
                    src="../../assets/images/tamogatok/Konasoft_Logo_turkiz.png"
                    class="p-20 bg-white"
                    alt=""
                  />
                </li>
                <li>
                  <img
                    src="../../assets/images/tamogatok/iib_logo_eng2.png"
                    class=""
                    alt=""
                  />
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="sub-footer fl-wrap">
      <div class="container">
        <div class="row">
          <div class="col-md-6">
            <div class="copyright">&#169; MADE WITH ♥ KONASOFT</div>
          </div>
          <div class="col-md-6">
            <div class="footer-social">
              <ul>
                <li>
                  <a href="https://www.facebook.com/petkupa/" target="_blank"
                    ><i class="fab fa-facebook-square"></i
                  ></a>
                </li>
                <li>
                  <a href="mailto:petkupa@gmail.com" target="_blank"
                    ><i class="far fa-envelope"></i> petkupa@gmail.com</a
                  >
                </li>
                <li>
                  <a href="tel:+36202773787" target="_blank"
                    ><i class="fas fa-phone-alt"></i> +36-20-277-3787</a
                  >
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <go-top-button></go-top-button>
  </footer>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'default-footer',
  data() {
    return {};
  },
  mounted() {
    window.FB.init({ xfbml: true, version: 'v7.0' });
  },
  created() {},
  methods: {},
  computed: {
    ...mapGetters({}),
  },
  watch: {},
  components: {},
};
</script>
<style scoped>
.footer-widget .btn:hover {
  background: #4db7fe;
  color: rgba(255, 255, 255, 0.71);
}
.footer-widget .partners img {
  max-width: 250px;
}
.footer-widget img.logo {
  max-width: 150px;
}

.footer-widget .partners li {
  text-align: center;
}
</style>
